import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('bm_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('bm_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (obj) => (obj && obj[lang]) || (obj && obj.en) || '';
  const toggle = () => setLang((p) => (p === 'en' ? 'hi' : 'en'));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
